import React from 'react';
import Avatar from 'assets/svgs/avatar/avatar-m-01.svg';
import DatePicker from 'react-date-picker';
// import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import './statics.scss';
import {RoleTypes} from '../enums';

const Statics = () => {
  const getStatics = (type) => (
    <div className="dashboard-list auto-height mb-4">
      <div className="download-icon d-flex align-items-center px-3">
        <a
          href="#22"
          onClick={(e) => e.preventDefault()}
          className="ml-auto mr-0 actions-ico"
        >
          <DatePicker isOpen={false} />
        </a>
        <h6 className="text-center w-100">{type}</h6>

        {/* <ReactHTMLTableToExcel */}
        {/*  className="ml-auto mr-0 actions-ico" */}
        {/*  table={`cat-table-${type.toLowerCase()}`} */}
        {/*  filename="tablexls" */}
        {/*  sheet="tablexls" */}
        {/*  buttonText={<img src={DownloadIcon} alt="" />}> */}
        {/* </ReactHTMLTableToExcel> */}
      </div>
      <div className="table-responsive statics-list">
        <table
          className="table table-bordered text-center mb-0"
          id={`cat-table-${type.toLowerCase()}`}
        >
          <thead>
            <tr className="bg-gray4">
              <th style={{minWidth: 140}} className="bg-gray4">
                Date
              </th>
              <th style={{minWidth: 140}} className="bg-gray4">
                team
              </th>
              <th style={{minWidth: 268}} className="bg-gray4">
                Editor
              </th>
              <th style={{minWidth: 140}} className="bg-gray4">
                Architectures
              </th>
              <th style={{minWidth: 140}}>Interiors</th>
              <th style={{minWidth: 140}}>Constructions</th>
              <th style={{minWidth: 140}}>Electronics</th>
              <th style={{minWidth: 140}}>Furniture</th>
              <th style={{minWidth: 140}}>Goods</th>
              <th style={{minWidth: 140}}>Total</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="bg-white">2020-12-11</td>
              <td className="bg-white">Anjali</td>
              <td className="bg-white">
                <div className="editor-name">
                  <img src={Avatar} alt="" className="mr-2" />
                  Amarjot Kaur
                </div>
              </td>
              <td className="bg-white">23</td>
              <td className="bg-white">23</td>
              <td className="bg-white">23</td>
              <td className="bg-white">23</td>
              <td className="bg-white">23</td>
              <td className="bg-white">23</td>
              <td className="bg-white">168</td>
            </tr>
            <tr>
              <td className="bg-white">2020-12-11</td>
              <td className="bg-white">Anjali</td>
              <td className="bg-white">
                <div className="editor-name">
                  <img src={Avatar} alt="" className="mr-2" />
                  Baljinder Kaur
                </div>
              </td>
              <td className="bg-white">23</td>
              <td className="bg-white">23</td>
              <td className="bg-white">23</td>
              <td className="bg-white">23</td>
              <td className="bg-white">23</td>
              <td className="bg-white">23</td>
              <td className="bg-white">168</td>
            </tr>
            <tr>
              <td className="bg-white">2020-12-11</td>
              <td className="bg-white">Anjali</td>
              <td className="bg-white">
                <div className="editor-name">
                  <img src={Avatar} alt="" className="mr-2" />
                  Anjali Madaan
                </div>
              </td>
              <td className="bg-white">23</td>
              <td className="bg-white">23</td>
              <td className="bg-white">23</td>
              <td className="bg-white">23</td>
              <td className="bg-white">23</td>
              <td className="bg-white">23</td>
              <td className="bg-white">168</td>
            </tr>
            <tr>
              <td className="bg-white">2020-12-11</td>
              <td className="bg-white">Anjali</td>
              <td className="bg-white">
                <div className="editor-name">
                  <img src={Avatar} alt="" className="mr-2" />
                  Balvir Kaur{' '}
                </div>
              </td>
              <td className="bg-white">23</td>
              <td className="bg-white">23</td>
              <td className="bg-white">23</td>
              <td className="bg-white">23</td>
              <td className="bg-white">23</td>
              <td className="bg-white">23</td>
              <td className="bg-white">168</td>
            </tr>
            <tr className="bg-gray4">
              <th className="bg-gray4"></th>
              <th className="bg-gray4"></th>
              <th className="bg-gray4"></th>
              <th className="bg-gray4">532</th>
              <th className="bg-gray4">245</th>
              <th className="bg-gray4">453</th>
              <th className="bg-gray4">254</th>
              <th className="bg-gray4">366</th>
              <th className="bg-gray4">234</th>
              <th className="bg-gray4">1,132</th>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );

  return (
    <>
      {getStatics(RoleTypes.Post)}
      {getStatics(RoleTypes.Company)}
      {getStatics(RoleTypes.Information)}
    </>
  );
};

export default Statics;
